import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const MONTHS = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
const DAYS = ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];

export default function AvailabilityCalendar({ busyDates = [], editable = false, onToggle, onMonthChange, initialMonth }) {
  const init = initialMonth ? new Date(`${initialMonth}-01T00:00:00`) : new Date();
  const [cursor, setCursor] = useState(new Date(init.getFullYear(), init.getMonth(), 1));
  const y = cursor.getFullYear();
  const m = cursor.getMonth();
  const startOffset = (new Date(y, m, 1).getDay() + 6) % 7;
  const daysInMonth = new Date(y, m + 1, 0).getDate();
  const busy = new Set(busyDates);

  const move = (dir) => {
    const next = new Date(y, m + dir, 1);
    setCursor(next);
    onMonthChange?.(`${next.getFullYear()}-${String(next.getMonth() + 1).padStart(2, "0")}`);
  };

  return (
    <div className="card p-4 sm:p-5" data-testid="availability-calendar">
      <div className="flex items-center justify-between mb-4">
        <button type="button" data-testid="calendar-prev-month" onClick={() => move(-1)} className="p-2 rounded-lg border border-white/10 text-slate-300 hover:text-[#D4AF37] hover:border-[#D4AF37]/50 transition-colors"><ChevronLeft size={16} /></button>
        <div className="font-bold text-slate-100">{MONTHS[m]} {y}</div>
        <button type="button" data-testid="calendar-next-month" onClick={() => move(1)} className="p-2 rounded-lg border border-white/10 text-slate-300 hover:text-[#D4AF37] hover:border-[#D4AF37]/50 transition-colors"><ChevronRight size={16} /></button>
      </div>
      <div className="grid grid-cols-7 gap-1 text-center text-[11px] font-bold text-slate-500 mb-2">
        {DAYS.map((d) => <div key={d}>{d}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {Array.from({ length: startOffset }).map((_, i) => <div key={`b${i}`} />)}
        {Array.from({ length: daysInMonth }).map((_, i) => {
          const d = i + 1;
          const ds = `${y}-${String(m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
          const isBusy = busy.has(ds);
          return (
            <button
              key={ds}
              type="button"
              data-testid={`calendar-day-${ds}`}
              disabled={!editable}
              onClick={() => onToggle?.(ds)}
              title={isBusy ? "DOLU" : "MÜSAİT"}
              className={`aspect-square rounded-lg text-xs font-bold transition-all ${
                isBusy
                  ? "bg-[#EF4444]/20 text-red-400 border border-[#EF4444]/40"
                  : "bg-[#10B981]/10 text-emerald-400 border border-[#10B981]/25"
              } ${editable ? "hover:scale-105 cursor-pointer" : "cursor-default"}`}
            >
              {d}
            </button>
          );
        })}
      </div>
      <div className="flex items-center gap-4 mt-4 text-xs text-slate-400">
        <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#10B981]" /> Müsait</span>
        <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#EF4444]" /> Dolu</span>
        {editable && <span className="text-slate-500">Güne tıklayarak DOLU / MÜSAİT işaretleyin</span>}
      </div>
    </div>
  );
}
